import { Box, Text, Image } from '@chakra-ui/react';
import React from 'react';
export interface BadgeCardProps {
	badge: { name: string; isBadgeEarned: boolean; badgeIcon: string; disabledBadgeTagLine: string; badgeCard: string; badgeTagLine: string };
	onClick: (badge: BadgeCardProps['badge']) => void;
}
const BadgeCard = ({ badge, onClick }: BadgeCardProps) => {
	const badgeName = badge?.name;

	return (
		<Box
			mx={{ base: 'auto', sm: '0px' }}
			w="full"
			cursor="pointer"
			borderRadius={'24px'}
			border="1px solid #F3F2F2"
			py="12px"
			px="6px"
			maxW="223px"
			bgColor={'white'}
			boxShadow={'0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)'}
			onClick={() => onClick(badge)}
		>
			<Image boxSize={'117px'} mx="auto" filter={badge?.isBadgeEarned ? '' : 'grayscale(1)'} src={badge?.badgeIcon} alt={badgeName} />
			<Text textAlign={'center'} color={badge?.isBadgeEarned ? '#4358F6' : '#848081'} mt="12px" textStyle="body2-md">
				{badgeName}
			</Text>
		</Box>
	);
};

export default BadgeCard;
